import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';

/**
 * 反映完了のコンポーネント
 */
export default {
    name: 'modalDeployed',
    template: '#modal_deployed_template',
    props: {
        // ページキー
        page_key: {
            type: String,
            default: '',
            required: false
        },
    },
    computed: {
        // ページURL
        pageUrl: function () {
            return this.$_yahooPageUrl(this.page_key);
        }
    },
    mixins: [
        commonMixin,
        modalMixin,
    ],
    methods: {
        // ページを開く
        openPage: function () {
            window.open(this.pageUrl, '_blank');
        },
        // 編集ページへ戻る
        editPage: function () {
            window.location.href = '/custom_page/edit?page_key=' + this.page_key;
        },
        // 一覧ページに戻る
        gotoList: function () {
            window.location.href = '/custom_page';
        },
    }
};

